/**
 * Toggles the menu icon on click.
 * @param {Object} structure_hours containing the lab hours on structure time ( Day Open & close time )
 * @return string the structure hours on the format hh:mm AM/PM
 */
function printLabTime(structure_hours) {
  // From php Carbon
  if (structure_hours instanceof Object && structure_hours.hasOwnProperty('date')) {
    return new Date(structure_hours.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  return new Date(structure_hours);
}

window.printLabTime = printLabTime;
